import React from "react";

const Loader = () => {
  return (
    <div id="loading" class="loading-wrap">
      <ul class="loading">
        <li>
          <img src={require("../assets/images/loading40.gif")} />
        </li>
        <li>Loading...</li>
        <br />
        <li>
          <span id="progress"></span>
        </li>
      </ul>
    </div>
  );
};

export default Loader;
